(function () {
  const DECO_MIN = 36;
  const BLANK_MIN = 12;
  const DECO_HANDLE = 'custom-decoration';

  function styleFromSku(sku) {
    return sku ? String(sku).split('-')[0].trim() : null;
  }

  function styleFromDecoProps(props) {
    const key = Object.keys(props || {}).find(
      (k) => k.trim().toLowerCase() === 'garment'
    );
    const m = key ? String(props[key]).match(/Style\s*#\s*(\d+)/i) : null;
    return m ? m[1] : null;
  }

  function evaluate(cart) {
    const errors = [];
    const garments = cart.items.filter((i) => i.handle !== DECO_HANDLE);
    const decos = cart.items.filter((i) => i.handle === DECO_HANDLE);

    let totalUnits = 0;

    garments.forEach((item) => {
      totalUnits += item.quantity;
    });

    // Blank orders require 12+ total garments.
    if (garments.length && totalUnits < BLANK_MIN) {
      errors.push(
        `Blank garments: ${totalUnits} of ${BLANK_MIN} minimum. Add ${BLANK_MIN - totalUnits} more to check out.`
      );
    }

    // Each custom-decoration line/design requires 36+ units.
    decos.forEach((deco) => {
      const style = styleFromDecoProps(deco.properties);
      const label = style ? `Style #${style}` : 'the selected garment';

      if (deco.quantity < DECO_MIN) {
        errors.push(
          `Custom decoration on ${label}: ${deco.quantity} of ${DECO_MIN} minimum per design. Add ${DECO_MIN - deco.quantity} more to check out.`
        );
      }
    });

    return errors;
  }

  function getCheckoutButtons() {
    return document.querySelectorAll(
      'button[name="checkout"], #CartDrawer-Checkout, #checkout'
    );
  }

  function render(errors) {
    const blocked = errors.length > 0;

    document.querySelectorAll('.axll-moq-msg').forEach((el) => el.remove());

    getCheckoutButtons().forEach((btn) => {
      btn.disabled = blocked;
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');

      if (blocked) {
        btn.style.opacity = '0.4';
        btn.style.cursor = 'not-allowed';

        const box = document.createElement('div');
        box.className = 'axll-moq-msg';
        box.style.cssText =
          'margin:0 0 1.2rem;padding:1.2rem 1.4rem;background:#fff4f4;border-left:3px solid #c00;color:#8a1f1f;font-size:1.3rem;line-height:1.5;text-align:left;width:100%;box-sizing:border-box';
        box.innerHTML = errors
          .map((error) => `<div style="margin:0.2rem 0">${error}</div>`)
          .join('');

        const anchor = btn.closest('.cart__ctas') || btn.parentNode;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(box, anchor);
        }
      } else {
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    });

    window.__axllMoqBlocked = blocked;
  }

  // Protect only checkout actions. Do NOT block product/cart forms just
  // because their action contains "/cart" — Add to Cart must always work.
  document.addEventListener(
    'click',
    function (event) {
      const btn =
        event.target.closest &&
        event.target.closest(
          'button[name="checkout"], #CartDrawer-Checkout, #checkout'
        );

      if (btn && window.__axllMoqBlocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        check();
      }
    },
    true
  );

  // Some Shopify cart templates submit the checkout button as part of a
  // /cart form. Block that form submission only when the form actually
  // contains a checkout control.
  document.addEventListener(
    'submit',
    function (event) {
      if (!window.__axllMoqBlocked) return;

      const form = event.target;
      if (!form || !form.querySelector) return;

      const checkoutButton = form.querySelector(
        'button[name="checkout"], #CartDrawer-Checkout, #checkout'
      );

      if (checkoutButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        check();
      }
    },
    true
  );

  async function check() {
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);

      const cart = await response.json();
      render(evaluate(cart));
    } catch (error) {
      console.error('Axll MOQ check failed', error);
    }
  }

  document.addEventListener('DOMContentLoaded', check);

  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // Give Shopify/cart components a moment to finish replacing their
      // sections before we evaluate the current cart.
      setTimeout(check, 50);
    });
  }

  // Cart buttons can be replaced dynamically by Shopify's cart rendering.
  // Re-check whenever a new checkout button appears.
  new MutationObserver(() => {
    const newCheckoutButton = document.querySelector(
      'button[name="checkout"]:not([data-axll-seen]), #CartDrawer-Checkout:not([data-axll-seen]), #checkout:not([data-axll-seen])'
    );

    if (newCheckoutButton) {
      getCheckoutButtons().forEach((button) =>
        button.setAttribute('data-axll-seen', '1')
      );
      check();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
